import { Alert, Typography } from "antd";

const { Text, Paragraph } = Typography;

export const DisabledSubStatusAlert = ({
  statusName,
  availableStatuses = [],
  style = {},
}) => {
  return (
    <Alert
      showIcon
      type="warning"
      className="alert-message-only"
      style={style}
      message={
        <>
          <Paragraph style={{ marginBottom: 0 }}>
            The current candidate status <Text strong>{statusName}</Text> is
            disabled in the client workflow.
          </Paragraph>

          {availableStatuses.length > 0 && (
            <>
              <Paragraph style={{ marginTop: 8, marginBottom: 4 }}>
                Candidate status can be changed to one of the following:
              </Paragraph>

              <ul style={{ marginBottom: 0 }}>
                {availableStatuses.map((status) => (
                  <li key={status}>
                    <Text strong>{status}</Text>
                  </li>
                ))}
              </ul>
            </>
          )}
        </>
      }
    />
  );
};
